// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import "quill/dist/quill.core.css"
import {
  resetForm,parseTime
} from "@/utils/ruoyi";
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
// import './element-variables.scss'
Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.resetForm = resetForm
Vue.prototype.parseTime = parseTime

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

// Vue.prototype.$globalUrl = '../vms';
// Vue.prototype.$globalHref = '../vms';
Vue.prototype.$globalUrl = 'https://www.sh12355.com/vms';
Vue.prototype.$globalHref = 'https://www.sh12355.com/vms';
// Vue.prototype.$globalUrl = 'http://183.194.254.214:30000/vms';
// Vue.prototype.$globalHref = 'http://183.194.254.214:30000/vms';
// Vue.prototype.$globalUrl = 'http://192.168.0.149:30015';
// Vue.prototype.$globalHref = 'http://192.168.0.149:30015';

// Vue.prototype.$globalUrl = '';//图片的前缀
// Vue.prototype.$globalHref = '/vms';//上传接口的前缀

// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('web_token') // 假设token存储在localStorage中
//   if (!token) {
//     // 如果页面需要认证，但是没有token，则重定向到登录页
//     next({ path: '/login' })
//   } else {
//     // 否则，继续正常的页面跳转
//     next()
//   }
// })

// 跳转后返回页面顶部
router.afterEach(() => {
  window.scrollTo(0,0);
})



// WEBPACK FOOTER //
// ./src/main.js